import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { whatsappMadeEvent } from '../../util/dataLayerMadeEvents.js';

import { IconWhatsapp } from '../index.js';

import css from './WhatsappButton.module.css';

const WhatsappButtonComponent = props => {
  const location = useLocation();
  const { currentUser } = props;

  const userId = currentUser?.id?.uuid || null;

  const onSendWhatsappEvent = ({ location, userId }) => {
    const { pathname, search } = location;

    whatsappMadeEvent({
      event: 'whatsapp_button_click',
      customerId: userId,
      pagePath: `${pathname}${search}`,
    });
  };

  return (
    <div className={css.whatsappBtnWrapper}>
      <a
        className={css.whatsappBtn}
        href="https://api.whatsapp.com/send/?phone=31638508749&text=Hello&type=phone_number&app_absent=0"
        target="_blank"
        onClick={() => onSendWhatsappEvent({ location, userId })}
      >
        <IconWhatsapp />
      </a>
    </div>
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user || {};

  return { currentUser };
};

const WhatsappButton = compose(connect(mapStateToProps))(WhatsappButtonComponent);

export default WhatsappButton;
